import { FirebaseApp } from 'firebase/app';
import { getDownloadURL, getStorage, ref } from 'firebase/storage';


export async function loadImage(app: FirebaseApp, name: string, placeholder = 'modules/shared/images/default-avatar.jpg') {
  return getDownloadURL(ref(getStorage(app), `images/${name}`))
    .catch(() => placeholder);
}